module.exports = __webpack_public_path__ + "img/pisces.9de166f5.svg";